import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDocumentTitle } from 'hooks';
import selectors from '../../selectors/selectors.js';
import AppStateHandler from 'components/AppStateHandler.js';
import ScreenLoader from '../ScreenLoader.js';
import { action } from 'lib/actionHelpers.js';

const AppRoute = ({ component: Component, loaderComponent: LoaderComponent, title, is404, isProtected, what, fixedWidth, ...rest }) => {
  const isMobile = useSelector(selectors.mobile);
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const loggedIn = useSelector((state) => state.user.loggedIn);
  const fullScreenMode = useSelector((state) => state.video.fullScreenMode);
  const routeKey = useSelector((state) => state.ui.routeKey);
  const notificationSliderOpen = useSelector(selectors.notificationSliderOpen);
  const computedMatchPath = `${((rest || {}).computedMatch || {}).path}_${routeKey || 'default'}`;
  const matchedServiceProviderId = (((rest || {}).computedMatch || {}).params || {}).serviceProviderId;
  const containerClass = title.replace(' ', '-').toLowerCase();
  const routeMatchesServiceProvider = serviceProviderId === matchedServiceProviderId && serviceProviderId !== null;
  const routeShouldRender = isProtected === false || (loggedIn && (!matchedServiceProviderId || routeMatchesServiceProvider));

  useDocumentTitle(title);

  return (
    <Route
      {...rest}
      key={computedMatchPath}
      render={() => {
        if ((isProtected && !loggedIn) || is404) {
          if (!is404) {
            action('SET_REDIRECT_FROM_LOGIN_PATH', rest.location.pathname);
          }
          return <Redirect to={{ pathname: '/login' }} />;
        } else {
          return (
            <div className={`route-container route-${containerClass}-container ${fullScreenMode ? 'full-screen-mode' : ''} ${notificationSliderOpen ? 'notification-slider' : ''}`}>
              <Component />
              {!routeShouldRender && !isMobile && <ScreenLoader component={LoaderComponent} />}
              <AppStateHandler isProtected={isProtected} fixedWidth={fixedWidth} />
            </div>
          );
        }
      }}
    />
  );
};

export default AppRoute;
